// AuthHeader.jsx - Logo + title + subtitle block shared by the auth screens.
//
// Every auth screen used to render this block itself, which is how the logo
// drifted apart (80px on login, 2.7rem everywhere else). Sharing one component
// means the screens cannot disagree again.
//
// Sizes come from the Figma auth flow ("Log in sign in"): the logo frame is
// 252x36 on both screens — the intrinsic size of companyname.svg — the title
// is Inter Bold 32px / Neutral 2, and the subtitle Inter Regular 16px /
// Neutral 5, 12px apart.
//
// `title`/`subtitle` are optional: SignUpSuccess shows the logo on its own and
// puts its heading below a confirmation checkmark.
import React from 'react';

const AuthHeader = ({ title, subtitle, className = '' }) => (
  <div className={`mb-8 flex flex-col items-center ${className}`}>
    <img
      src="/assets/companyname.svg"
      alt="Bloom IQ"
      width={252}
      height={36}
      className="h-[36px] w-[252px] max-w-full"
    />
    {(title || subtitle) && (
      <div className="mt-10 flex flex-col items-center gap-[12px] text-center">
        {title && (
          <h2 className="font-['Inter'] text-[32px] font-bold leading-[1.5] text-[#282A29]">
            {title}
          </h2>
        )}
        {subtitle && (
          <p className="font-['Inter'] text-[16px] font-normal leading-[21.75px] text-[#5D625F]">
            {subtitle}
          </p>
        )}
      </div>
    )}
  </div>
);

export default AuthHeader;
